import { type SliderTrackSlotProps } from '@mui/base'
import { clsx } from 'clsx'
import { forwardRef } from 'react'

export const SliderTrack = forwardRef<HTMLSpanElement, SliderTrackSlotProps>(
  function SliderTrack(props, ref) {
    const {
      className,
      // eslint-disable-next-line @typescript-eslint/no-unused-vars -- variable is not needed for rendering
      ownerState,
      ...rest
    } = props

    return (
      <span className={clsx('slider__track', className)} ref={ref} {...rest} />
    )
  },
)
